import { isEmpty } from 'lodash';

class PortfolioSettingMap {
    static mapPortfolioSettingToSave(record) {
        if (!isEmpty(record)) {
            return {
                creditReportingCompanyId: record.creditReportingCompanyId,
                name: record.name,
                lotId: record.lotId,
                convenienceFee: record.convenienceFee || 0,
                isDefault: record.isDefault || false,
                achConvenienceFee: record.achConvenienceFee || 0,
            };
        }

        return {};
    }

    static mapPortfolioSettingToUpdate(record, selectedPortfolioId) {
        if (!isEmpty(record) && selectedPortfolioId === record.portfolioId) {
            return {
                id: selectedPortfolioId,
                input: {
                    creditReportingCompanyId: record.creditReportingCompanyId,
                    name: record.name,
                    lotId: record.lotId,
                    convenienceFee: record.convenienceFee || 0,
                    isDefault: record.isDefault || false,
                    achConvenienceFee: record.achConvenienceFee || 0,
                },
            };
        }

        return {};
    }
}

export default PortfolioSettingMap;
